import React from 'react';
import { VolunteerRequestCard } from './VolunteerRequestCard';

export function VolunteerRequestPage(){
  return(
    <>
      <VolunteerRequestCard/>
    </>
  )
}